import type {EntryPoint} from 'react-relay'
import {getRequest} from 'relay-runtime'

import {makeResource} from '../../../utils/makeResource'
import {getAccountRootProjectId} from '../PipelinesPages/PipelinesPages.consts'

import type {SharedSettingsSshKeysPageComponent} from './SharedSettingsSshKeysPage'
import {query} from './SharedSettingsSshKeysPage.queries'

export const SharedSettingsSshKeysPageEntrypoint: EntryPoint<SharedSettingsSshKeysPageComponent> = {
  root: makeResource(
    'SharedSettingsSshKeysPage',
    () => import(/* webpackChunkName: "SharedSettingsSshKeysPage" */ './SharedSettingsSshKeysPage'),
  ),
  getPreloadProps: () => ({
    queries: {
      main: {
        parameters: getRequest(query),
        variables: {
          projectId: getAccountRootProjectId(),
        },
        options: {networkCacheConfig: {metadata: {essential: true}}},
      },
    },
  }),
}
